import Vue from 'vue';
import BaseComponent from './baseFormMixin.jsx';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';

import { appSettings } from '@/Shared/appSettings.js';

Vue.component('sform-date', {
    mixins: [BaseComponent],
    data: () => ({
        pickervisible: false,
    }),
    props: {
    },
    created() {
    },
    mounted() {
        this.loadComplete();
    },
    computed: {
        datevalue() {
            return this.getFormattedDate(this.itemvalue, true);
        }
    },
    methods: {
        saveDate() {
            this.pickervisible = false;
        },
        cancelDate() {
            this.pickervisible = false;
        },
        dateChanged(value) {
            // Ex: "2021-03" or "2021-06-17"
        },
        getFormattedDate(value, accountForTimezone) {
            if (!value)
                return '';

            // Don't try to parse incomplete dates
            if (value?.length < 10) return value;

            // Check if we have a properly formatted date string
            const parts = value.split(/[-/.]/);
            if (parts.length !== 3) return value;

            // Ensure we have complete year, month, day values
            if (parts.some(part => !part)) return value;

            let yearStr = parts[0].replace(/^0+/, '');
            let monthStr = parts[1];
            let dayStr = parts[2];
            
            if (dayStr.length == 4 && yearStr.length == 2) {
                // swap the day and year since the format coming in isn't ISO format, only happens when we initialize.
                const temp = yearStr;
                yearStr = dayStr;
                dayStr = temp;
            }

            if (yearStr.length < 4 || monthStr.length !== 2 || dayStr.length !== 2) return value;

            var parseValue = value;

            if (yearStr.length > 4) {
                const sliceIndex = yearStr.length - 4;
                parseValue = parseValue.slice(sliceIndex);
            }

            const dt = new Date(Date.parse(parseValue));

            if (accountForTimezone) {
                const offset = dt.getTimezoneOffset();
                dt.setMinutes(dt.getMinutes() + offset);
            }

            const year = dt.getFullYear();
            const month = dt.getMonth() + 1;
            const day = dt.getDate();

            const str = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
            console.log(`Formatting ${value} to ${str} using ${dt.toString()}`);
            return str;
        },
        sync_fromlocaldate(value) {
            const str = this.getFormattedDate(value, true);

            utils.debug(`DatePicker writing date to model value:'${value}' as '${str}'`);

            this.sync(str);
        },
    },
    render() {
        let scopedSlots = {
            message: ({message}) => {
                return <translation-container context={this} value={message}></translation-container>
            }
        }

        let slots = [
            <translation-container slot="label" context={this} value={this.labelText}></translation-container>,
        ];

        const input = (
            <v-text-field
                class="caption pa-0 ma-0"
                style={{ width: "100%" }}
                outlined single-line dense hide-details
                value={this.datevalue}
                rules={this.rules}
                type="date"
                on-input={(value) => this.sync_fromlocaldate(value)}
                scopedSlots={scopedSlots}
                hint={this.hintText}
                on-blur={() => {
                    this.onBlur();
                }}  
                on-focus={this.onFocus}
                persistent-hint={appSettings.DebugTranslationPrefixSetting}
            >{slots}</v-text-field>
        );

        if (this.appearance)
            input.componentOptions.propsData = { ...input.componentOptions.propsData, ...this.appearance };

        if (this.directives) {
            if (input.data.directives)
                input.data.directives = [...input.data.directives, ...this.directives];
            else
                input.data.directives = this.directives;
        }

        return input;

        /* Using the vuetify date-time pickers...
        let popup = (
            <v-menu
                close-on-content-click={false}
                value={this.pickervisible}
                on-input={(value) => this.pickervisible = value}
                transition="scale-transition"
                offset-y
                scopedSlots={{
                    activator: ({ on, attrs }) => {
                        const input =
                            <v-text-field
                                {...{ on }} {...{ attrs }}
                                class="caption pa-0 ma-0"
                                style={{ width: "100%" }}
                                append-icon="mdi-calendar"
                                outlined single-line dense hide-details
                                value={this.itemvalue}
                                type="datetime-local"
                                on-input={(value) => this.sync(value)}>
                            </v-text-field>;

                        if (this.appearance)
                            input.componentOptions.propsData = { ...input.componentOptions.propsData, ...this.appearance };

                        return input;
                    }
                }}>

                <v-card>
                    <v-row dense>
                        <v-col>
                            <v-date-picker
                                value={this.datevalue}
                                on-change={(e) => this.dateChanged(e)}
                                type="date"
                                no-title
                                scrollable>
                            </v-date-picker>

                            <v-time-picker
                                landscape
                                no-title
                            >
                            </v-time-picker>
                        </v-col>
                    </v-row>

                    <v-card-actions>
                        <v-btn text color="primary" on-click={(e) => this.cancelDate(e)}>
                            Cancel
                        </v-btn>
                        <v-btn text color="primary" on-click={(e) => this.saveDate(e)}>
                            OK
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-menu>
        );

        return popup;
        */
    }
});